import AppReportLayout from './AppReportLayout';

export default AppReportLayout;
